import { render, staticRenderFns } from "./housemaid-document-info.vue?vue&type=template&id=56d05cd1&scoped=true&"
import script from "./housemaid-document-info.vue?vue&type=script&lang=js&"
export * from "./housemaid-document-info.vue?vue&type=script&lang=js&"
import style0 from "./housemaid-document-info.vue?vue&type=style&index=0&id=56d05cd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d05cd1",
  null
  
)

export default component.exports